import { render, staticRenderFns } from "./Observation.vue?vue&type=template&id=1ec40ee2&"
import script from "./Observation.vue?vue&type=script&lang=js&"
export * from "./Observation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports